// extracted by mini-css-extract-plugin
export default {"container":"ResourceFilter_container__vqDc2"};